import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Switch,
  Typography,
} from '@mui/material';

const Chat = ({ appInfo, setAppInfo, saveAppInfo }) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    saveAppInfo();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <CardContent>
          <Typography gutterBottom variant="h3">
            Chat
          </Typography>
          <Box mb={3}>
            <FormControl component="fieldset">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={appInfo.chatEnabled}
                      onChange={(event) => {
                        setAppInfo({
                          ...appInfo,
                          chatEnabled: event.target.checked,
                        });
                      }}
                      name="chatEnabled"
                    />
                  }
                  label="Chat"
                />
              </FormGroup>
              <FormHelperText>
                Allow your paying subscribers to start a chat with you. They can
                ask you to check their form, training plan advice, etc.
              </FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2}>
            <Button variant="contained" color="secondary" type="submit">
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </form>
  );
};

export default Chat;
